import { flagImages } from '../legacy-bridge';

/** The flag file for a country or region code, in any casing. */
export function getFlagSrc(code: string | undefined): string | undefined {
  if (!code) {
    return undefined;
  }

  return flagImages[code.toUpperCase()];
}
